import { Checkbox, Slider } from 'antd';
import { useState, useContext } from 'react';
import { GlobalContext } from 'GlobalContext';
import { isPhoneSize } from 'utils/util';

function InvestmentType(props) {
    const { filter, setFilter } = props;
    const investmentTypes = filter['Investment Type'];
    function Button(props) {
        const { text } = props;
        const [isHovered, setIsHovered] = useState(false);

        const toggleItem = (text) => {
            const updated = investmentTypes.includes(text)
                ? investmentTypes.filter((item) => item !== text)
                : [...investmentTypes, text];

            setFilter((prev) => ({
                ...prev,
                'Investment Type': updated,
            }));
        };

        // background
        function getBackgroundColor() {
            // no includes -> white
            if (!investmentTypes.includes(text)) {
                return 'white';
            }
            // includes and hover -> rgb(64, 150, 255)
            // includes and no hover -> rgb(23, 119, 255)
            return isHovered ? 'rgb(64, 150, 255)' : 'rgb(23, 119, 255)';
        }

        // color
        function getColor() {
            // includes -> none
            if (investmentTypes.includes(text)) {
                return 'white';
            }
            // no includes and hover -> rgb(23, 119, 255)
            // no includes and no hover -> rgb(217, 217, 217)
            return isHovered ? 'rgb(23, 119, 255)' : 'rgb(217, 217, 217)';
        }

        // border
        function getBorder() {
            // includes -> none
            if (investmentTypes.includes(text)) {
                return 'none';
            }
            // no includes and hover -> 1px solid rgb(23, 119, 255)
            // no includes and no hover -> 1px solid rgb(217, 217, 217)
            return isHovered
                ? '1px solid rgb(23, 119, 255)'
                : '1px solid rgb(217, 217, 217)';
        }

        return (
            <div
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <button
                    onClick={(e) => toggleItem(e.target.innerText)}
                    style={{
                        background: getBackgroundColor(),
                        color: getColor(),
                        border: getBorder(),
                        width: '120px',
                        height: '25px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                    }}
                >
                    {text}
                </button>
            </div>
        );
    }
    return (
        <div style={{}}>
            <div style={{ marginBottom: '10px' }}>Investment Type</div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                }}
            >
                <Button text={'Equity'} />
                <Button text={'Debt'} />
            </div>
        </div>
    );
}

function InvestmentStatus(props) {
    const { filter, setFilter } = props;
    const investmentStatus = filter['Investment Status'];

    function CustomCheckBox(props) {
        const { text } = props;
        const onChange = (e) => {
            const updated = investmentStatus.includes(text)
                ? investmentStatus.filter((item) => item !== text)
                : [...investmentStatus, text];

            setFilter((prev) => ({
                ...prev,
                'Investment Status': updated,
            }));
        };
        return (
            <Checkbox
                checked={investmentStatus.includes(text)}
                onChange={onChange}
            >
                {text}
            </Checkbox>
        );
    }
    return (
        <div>
            <div style={{ marginBottom: '10px' }}>Investment Status</div>
            <CustomCheckBox text={'New'} />
            <CustomCheckBox text={'Open'} />
            <CustomCheckBox text={'Closed'} />
        </div>
    );
}

function MinimumInvestment(props) {
    const { filter, setFilter } = props;
    const [leftValue, setLeftValue] = useState(0);
    const [rightValue, setRightValue] = useState(200000);
    // const onChangeComplete = (value) => {
    //     console.log('onChangeComplete: ', value);
    // };
    const onChange = (value) => {
        // console.log('onChange: ', value);
        setLeftValue(value[0]);
        setRightValue(value[1]);
        const updated = [value[0], value[1]];
        setFilter((prev) => ({
            ...prev,
            'Minimum Investment': updated,
        }));
    };
    return (
        <div>
            <div style={{ marginBottom: '10px' }}>Minimum Investment</div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    placeItems: 'center',
                }}
            >
                <div>{`${leftValue / 1000}k`}</div>
                <Slider
                    range
                    step={10000}
                    min={0}
                    max={200000}
                    defaultValue={[0, 200000]}
                    tooltip={{ formatter: (value) => `${value / 1000}k` }}
                    onChange={onChange}
                    // onChangeComplete={onChangeComplete}
                    style={{ flex: 1, margin: '0 20px' }}
                />
                <div>{`${rightValue / 1000}k`}</div>
            </div>
        </div>
    );
}

function Term(props) {
    const { filter, setFilter } = props;
    const term = filter['Term'];
    // console.log(filter);

    function CustomCheckBox(props) {
        const { text } = props;
        const onChange = (e) => {
            const updated = term.includes(text)
                ? term.filter((item) => item !== text)
                : [...term, text];

            setFilter((prev) => ({
                ...prev,
                Term: updated,
            }));
        };
        return (
            <Checkbox checked={term.includes(text)} onChange={onChange}>
                {text}
            </Checkbox>
        );
    }
    return (
        <div>
            <div style={{ marginBottom: '10px' }}>Term</div>
            <CustomCheckBox text={'0-6 Months'} />
            <CustomCheckBox text={'6-24 Months'} />
            <CustomCheckBox text={'24 Months+'} />
        </div>
    );
}

export function OfferingFilters() {
    const { offeringFilter, setOfferingFilter } = useContext(GlobalContext);
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: isPhoneSize() ? '10px' : '20px',
                marginBottom: '20px',
                fontWeight: 'bold',
                alignItems: isPhoneSize() ? 'center' : '',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: isPhoneSize() ? 'column' : 'row',
                    gap: isPhoneSize() ? '10px' : '40px',
                }}
            >
                <div style={{ width: '300px' }}>
                    <InvestmentType
                        filter={offeringFilter}
                        setFilter={setOfferingFilter}
                    />
                </div>
                <div style={{ flex: 1 }}>
                    <InvestmentStatus
                        filter={offeringFilter}
                        setFilter={setOfferingFilter}
                    />
                </div>
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: isPhoneSize() ? 'column' : 'row',
                    gap: isPhoneSize() ? '10px' : '40px',
                }}
            >
                <div style={{ width: '300px' }}>
                    <MinimumInvestment
                        filter={offeringFilter}
                        setFilter={setOfferingFilter}
                    />
                </div>
                <div style={{ flex: 1 }}>
                    <Term
                        filter={offeringFilter}
                        setFilter={setOfferingFilter}
                    />
                </div>
            </div>
        </div>
    );
}
